
import { privacyModeTextFormatterMixin } from '@/mixins';
import FormatterService from "@/service/FormatterService";

export default {
    name: "PortfolioKpiValueChange",

    mixins: [privacyModeTextFormatterMixin],

    data() {
        return {
            isVisible: false,
            format: new FormatterService()
        }
    },

    computed: {
        secondaryTotals() {
            return this.$store.state.preferences.kpiTotalData?.secondaryTotals || {};
        },
    },

    methods: {
        openWindow() {
            this.isVisible = true
        },
        closeWindow() {
            this.isVisible = false
        },
        onKeyDown(e) {
            if (e.key === 'Escape') this.closeWindow();
            if (e.key === 'Enter' && this.isVisible) {
                this.closeWindow()
            }
        },
        getTextColorClass(value) {
            if (!value) {
                return ''
            }

            return value > 0 ? 'text-total--positive' : 'text-total--negative' 
        }
    },

    beforeMount() {
        this.$root.$on("request-open-kpi-value-change-popup", this.openWindow);
        window.addEventListener('keydown', this.onKeyDown)
    },

    beforeUnmount() {
        this.$root.$off("request-open-kpi-value-change-popup", this.openWindow);
        window.removeEventListener('keydown', this.onKeyDown)
    }
}
